import React from 'react';

// Libellé + champ texte du site vitrine (.mkt-label / .mkt-input).
// Le libellé reste optionnel pour les usages composés (préfixe/suffixe).
interface TextFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: React.ReactNode;
}

const TextField: React.FC<TextFieldProps> = ({ label, className = '', ...rest }) => {
  const input = (
    <input className={['mkt-input', className].filter(Boolean).join(' ')} {...rest} />
  );
  if (!label) return input;
  return (
    <>
      <label className="mkt-label">{label}</label>
      {input}
    </>
  );
};

export default TextField;
